import React, { Component } from 'react'
import { isAutoplaySupported } from '../../functions/visual'
import LogoLight from '../../images/logo_light.svg'
import LogoDark from '../../images/logo.svg'
import AndroidVideo from '../../android_bg.mp4'
import Video from '../../bg.mp4'
import Headroom from 'react-headroom'
import VisibilitySensor from 'react-visibility-sensor'
import Slideshow from '../../components/Slideshow'
import HeadlineAnimation from '../../components/HeadlineAnimation'
import '../../styles/css/header.css'

const positions = [
  "30%",
  "center center",
  "center center",
  "center center",
  "30%",
  "70%",
  "80%",
  "center center",
  "center center",
  "30%",
  "30%",
  "70%",
  "center center",
  "60%",
  "center center",
  "center center",
]

const slides = [
  "01.jpg",
  "02.jpg",
  "03.jpg",
  "04.jpg",
  "05.jpg",
  "06.jpg",
  "07.jpg",
  "08.jpg",
  "09.jpg",
  "10.jpg",
  "11.jpg",
  "12.jpg",
  "13.jpg",
  "14.jpg",
  "15.jpg",
  "16.jpg",
]

const menuLinks = [
  { title: 'About us', target: 'about' },
  { title: 'Film portfolio', target: 'film' },
  { title: 'Photography', target: 'photography' },
  { title: 'Music production', target: 'music' },
  { title: 'Services', target: 'services' },
  { title: 'Contact', target: 'contact' }
]

class Header extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menuActive: false,
      menuLinks: menuLinks,
      pinned: false,
      autoplaySupported: false,
      isAndroid: false,
      backgroundPositionX: 0
    }
  }

  startSlideShow = () => {
    this.setState({
      currentSlide: 0
    })
  }

  componentDidMount = () => {
    isAutoplaySupported(supported => {
      if(supported) {
        this.setState({ autoplaySupported: true })
        var ua = navigator.userAgent.toLowerCase();
        var isAndroid = ua.indexOf("android") > -1;
        if(isAndroid) {
          return this.setState({ autoplaySupported: true, isAndroid: true })
        }
        this.setState({ autoplaySupported: true })
      } else {
        this.setState({ autoplaySupported: false })
      }
    })
  }

  toggleMenu = () => {
    if(this.state.menuActive) {
      document.body.removeAttribute("style")
      this.setState({ menuActive: false })
    } else {
      document.body.style.overflow = "hidden"
      this.setState({ menuActive: true })
    }
  }

  handleMenuClick = e => {
    document.body.removeAttribute("style")
    this.setState({
      menuActive: false
    })
    this.props.scroll(e.target.name)
  }

  scrollDown = () => {
    document.body.removeAttribute("style")
    this.setState({
      menuActive: false
    })
    this.props.scroll('about')
  }

  handleOnPin = () => {
    this.setState({
      pinned: true
    })
  }

  handleOnUnpin = () => {
    this.setState({
      pinned: false
    })
  }

  render() {

    const section = {
      target: '/',
      title: 'New Ground Entertainment'
    }
    const { texts = [], socials = {} } = this.props

    return(
      <div className="header">

        <Headroom pinStart={0}>
          <StickyMenu 
            links={this.state.menuLinks} 
            onClick={this.handleMenuClick}
            onToggleSideMenu={this.props.toggleSidebar}
            menuActive={this.props.sideMenuActive} />
        </Headroom>

        <header id="header">
              
              {this.state.autoplaySupported ? <HeaderVideo isAndroid={this.state.isAndroid} /> : <Slideshow images={slides} positions={positions} />}

              {this.state.menuActive && <HeaderMenu menuActive={this.state.menuActive} links={this.state.menuLinks} onClick={this.handleMenuClick} />}
              <div className="header-content">
                <div className="header-content-inner">
                      
                        <div className="header-top">
                            <div className="col">
                                <img src={LogoLight} alt="New Ground Entertainment" />
                            </div>
                            <div className="col">
                                <MenuButton 
                                        menuActive={this.state.menuActive}
                                        onClick={this.toggleMenu} />
                                <SideMenuButton 
                                        menuActive={this.props.sideMenuActive}
                                        onClick={this.props.toggleSidebar} />
                            </div>
                        </div>

                      <div className="header-middle">
                          <HeadlineAnimation texts={texts} />
                      </div>
                      
                      <div className="header-bottom">
                          <div className="col">
                              <a className="vimeo" href={socials.vimeo} target="_blank"></a>
                              <a className="instagram" href={socials.instagram} target="_blank"></a>
                          </div>
                          <div className="col">
                          <VisibilitySensor onChange={(isVisible) => isVisible && this.props.onActive(section)}>
                              <button onClick={this.scrollDown}></button>
                          </VisibilitySensor>
                          </div>
                      </div>
                </div>
              </div>
        </header>
      </div>
    )
  }

}

const MenuButton = ({ menuActive, onClick }) => (
  <button className={menuActive ? 'desktopMenu close' : 'desktopMenu open'} onClick={onClick}>
        <span></span>
        <span></span>
        <span></span>
  </button>
)

const SideMenuButton = ({ menuActive, onClick }) => (
  <button className={menuActive ? `sideMenuButton close` : `sideMenuButton open`} onClick={() => onClick(!menuActive)}>
        <span></span>
        <span></span>
        <span></span>
  </button>
)

const HeaderMenu = ({ links, onClick }) => (
  <div className="header-menu">
    <div className="header-menu-content">
        {links.map((link,index) => 
          <button 
            key={index} 
            name={link.target} 
            onClick={onClick}>{link.title}</button>
        )}
    </div>
  </div>
)

const StickyMenu = ({ links, onClick, onToggleSideMenu, sideMenuActive }) => (
  <div className="header-sticky-menu">
    <div className="header-sticky-menu-content">
        <div className="container">
            <div className="col">
                <img src={LogoDark} alt="New Ground Entertainment" />
            </div>
            <div className="col">
                <div className="links">
                  {links.map((link,index) => 
                    <button 
                      key={index} 
                      name={link.target} 
                      onClick={onClick}>{link.title}</button>
                  )}
                </div>
                <div className="sticky-button">
                  <button className={sideMenuActive ? `close` : `open`} onClick={onToggleSideMenu}>
                    <span></span>
                    <span></span>
                    <span></span>
                  </button>
                </div>
            </div>
        </div>
    </div>
  </div>
)

const HeaderVideo = ({ isAndroid }) => (
  <div className="header-video">
    <video preload="auto" autoPlay muted loop id="video" className={isAndroid ? 'android-video' : 'desktop-video'}>
          <source src={isAndroid ? AndroidVideo : Video} type="video/mp4" />
    </video>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/containers/home/header.js